import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as _ from "lodash";
import { Link } from 'react-router-dom';

class CustomNavLink extends Component {
    render() {
        const isActive = this.props.to === window.location.pathname;
        const activeClass = isActive ? 'active' : '';

        return (
            <li className={_.join(Array.of('nav-item', activeClass), ' ')}>
                <Link to={this.props.to} className="nav-link" {...this.props}>
                    {this.props.children}
                </Link>
            </li>
        );
    }
}

CustomNavLink.propTypes = {
    router: PropTypes.object
};

export default CustomNavLink;